export default "__VITE_ASSET__DLVdrPwF__"